module.exports = __webpack_public_path__ + "img/ae.98281a5e.svg";